enum GameType {
  VERSUS,
  LOCAL,
  COMPUTER,
}

export default GameType;
